import { API_BASE_URL } from "utils/constants";

const HistoryManagementPaths = {
  get_historys: `${API_BASE_URL}/history/get-history?:query`,

  delete_history: `${API_BASE_URL}/history/delete-history`,
  
  delete_history_user: `${API_BASE_URL}/history/delete-history-user`
};

export default HistoryManagementPaths;
